import defaultWebIDeal from '#themes/default/web/components/iDeal/iDeal.js';

import cBillingForm from '#themes/avast/web/components/billingForm/billingForm.js';
import cFormLine from '#themes/avast/web/components/formLine/formLine.js';
import cSelect from '#themes/avast/web/components/select/select.js';

export default {
	components: {
		cBillingForm,
		cFormLine,
		cSelect
	},
	extends: defaultWebIDeal
};
